<script>
	export let value = 0;
	const formatPercent = (value) =>
		value.toLocaleString("en", {
			style: "percent",
			minimumFractionDigits: 2,
		});

	$: progressWidth = 100 - ((value * 100) / 40) * 100;
	$: t = 0.4 - value * 100;
</script>

<style>
	.progress-bar-container {
		height: 100%;
		margin: 0 auto;
		position: relative;

		border-radius: 5px;
		overflow: hidden;
	}
	.progress-bar-child {
		width: 100%;
		height: 100%;
	}
	.progress {
		color: white;
		text-align: center;
		animation-direction: reverse;
		background: #e5405e;
	}
	.shrinker {
		background-color: gray;
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
	}
	.gradient {
		background: rgb(0, 105, 12);
		background: linear-gradient(
			90deg,
			rgba(0, 105, 12, 1) 0%,
			rgb(175, 172, 12) 4%,
			rgb(238, 204, 10) 5%,
			rgb(250, 54, 19) 40%,
			rgba(250, 10, 12, 1) 100%
		);
	}
</style>

<div class="">
	<!-- <div class="col-10">
		<div class="progress-bar-container">
			<div class="progress-bar-child progress gradient" />
			<div
				class="progress-bar-child shrinker timelapse"
				style="width: {100 - (value / 0.4) * 100}%" />
		</div>
	</div> -->
	<div class="col-12 bg-dark text-light text-center">
		<span class="display-4">{formatPercent(value) === "0.10%" ? "< 0.10%" : formatPercent(value) }</span>
	</div>
</div>
<!-- <div class="row m-0 p-0 mt-1">
	<div style="width: 4%;" class="text-right">2%</div>
	<div style="width: 8%;" class="text-right">5%</div>
	<div style="width: 71%;" class="text-right">40%</div>
	<div style="width: 17%;" class="text-center"><strong>Risk</strong></div>
</div> -->
